<template>
  <div class="cookie-setup">
    <div class="grid-x grid-margin-x grid-margin-y">
      <div class="cell small-12 large-6">
        <h3>
          Functional Cookies
        </h3>
        <div class="margin-bottom-1">
          <SwitchInput
            :on="true"
            :disabled="true"
            :emit-on-load="false"
            v-slot:before="props"
          >
            <span class="margin-right-1">
              <span v-if="props.on">On</span>
              <span v-else>Off</span>
            </span>
          </SwitchInput>
        </div>
        <p>
          Functional Cookies are enabled by default at all times so that we can
          save your preferences for cookie settings and ensure site works and
          delivers best experience.
        </p>
      </div>
      <div class="cell small-12 large-6">
        <h3>
          3rd Party Cookies
        </h3>
        <div class="margin-bottom-1">
          <SwitchInput
            :on="!isSet('3rd_party_consent')"
            :emit-on-load="false"
            @change="change('3rd_party_consent', $event)"
            v-slot:before="props"
          >
            <span class="margin-right-1">
              <span v-if="props.on">On</span>
              <span v-else>Off</span>
            </span>
          </SwitchInput>
        </div>
        <p>
          This website uses Google Analytics to collect anonymous information such
          as the number of visitors to the site, and the most popular pages.<br />
          Keeping this cookie enabled helps us to improve our website.
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCookie from './BaseCookie';
import SwitchInput from '../SwitchInput';
export default {
  name: 'CookieSetup',
  mixins: [BaseCookie],
  components: { SwitchInput },
  methods: {
    change(type, value) {
      if (!value) {
        this.add(type);
      } else {
        this.remove(type);
      }
      this.add('cookie_consent');
    },
  },
};
</script>
